import { CustomFieldsDataResolver, LoadCssResolver } from '@b2b/common/resolvers';
import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { ProgramsListAdminBookingView } from './admin/booking/booking';
import { ProgramsListAdminOrderView } from './admin/order/order';
import { ProgramsListControllerModule } from './controllers/ProgramsListController';

export const ProgramsListView = angular
  .module('acme.view.application.programs.list', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.service.helpers',
    ProgramsListControllerModule,
    ProgramsListAdminOrderView,
    ProgramsListAdminBookingView,
  ])

  .config(function config($stateProvider: StateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default

    $stateProvider.state({
      name: 'application.programs.list',
      url: '/list?templateId&templateName&startTime',
      views: {
        'subview-main': {
          controller: 'ProgramsListController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/programs/list/list.tpl.html',
        },
      },
      data: {
        pageTitle: 'Events List',
        permissions: [
          'EVENT_VIEW',
          'EVENT_DELETE',
          'ORDER_REBOOK',
          'ORDER_CREATE',
          'ORDER_UPDATE',
          'ACCT_ORDERS_CREATE',
          'ACCT_ORDERS_UPDATE',
          'ORDER_VIEW',
          'EVENT_CALENDAR_VIEW',
          'EVENT_TEMPLATE_VIEW',
          'COMBO_TEMPLATE_VIEW',
        ],
        enablePreferences: true,
      },
      resolve: {
        CustomFieldsData: CustomFieldsDataResolver(),
        istevenMultiselectCss: LoadCssResolver({ id: 'isteven-multi-select', url: '/assets/isteven-multi-select.css' }),
      },
    });
  }).name;
